import styled from "styled-components";

export const PageSelectContent = styled.div``;

export const PagesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #dadada;
  max-height: 300px;
  overflow-y: auto;
`;

export const ListItem = styled.li`
  padding: 0 20px;
  font-size: 14px;
  border-bottom: 1px solid #efefef;

  a {
    padding: 13px 0;
    color: #212121;
    text-decoration: none;
    display: block;
  }

  &:hover{
    background-color: #E9F6FF;
  }

`;

export const Button = styled.button`
  display: block;
  padding: 12px 20px;
  border: none;
  cursor: pointer;
  outline: none;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  text-align: center;
  background-color: #44adf8;
  
  &:hover {
    background-color: #28a4f1;
  }
  > span {
    margin-left: 5px;
  }
`;
